<div class="grouped-dropdown">
  <p class="grouped-dropdown-label b2">{{ label() }}</p>

  <button
    type="button"
    class="grouped-dropdown-trigger"
    [class.grouped-dropdown-trigger-open]="isOpen()"
    [class.grouped-dropdown-trigger-disabled]="disabled()"
    [attr.aria-disabled]="disabled()"
    [attr.tabindex]="disabled() ? -1 : null"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="listbox"
    (click)="togglePanel($event)">
    <span
      class="grouped-dropdown-value b1"
      [class.grouped-dropdown-value-placeholder]="
        displayValue() === placeholder()
      ">
      {{ displayValue() }}
    </span>
    <span class="grouped-dropdown-chevron" aria-hidden="true">
      <svg
        data-p-icon="chevron-down"
        class="grouped-dropdown-chevron-icon"></svg>
    </span>
  </button>

  <p-popover
    #popover
    mHideOnWindowScroll
    styleClass="grouped-dropdown-panel"
    appendTo="body"
    [dismissable]="true"
    (onShow)="onShow()"
    (onHide)="onHide()">
    <!-- Keep outside-click dismiss reliable (PrimeNG selfClick). -->
    <div
      class="grouped-dropdown-content"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()">
      <div class="grouped-dropdown-search">
        <m-input-search
          #searchInput
          placeholder="Search"
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)">
        </m-input-search>
      </div>

      <div class="grouped-dropdown-list">
        @if (filteredGroups().length === 0) {
          <p class="grouped-dropdown-empty b1">No results found</p>
        } @else {
          @for (group of filteredGroups(); track $index) {
            <p class="grouped-dropdown-section-title b3">{{ group.label }}</p>
            <div class="m-divider grouped-dropdown-divider"></div>

            @if (group.type === "single") {
              @for (item of group.items; track item.value) {
                <button
                  type="button"
                  class="grouped-dropdown-option"
                  [class.grouped-dropdown-option-selected]="
                    selectedSingleValue() === item.value
                  "
                  (click)="selectSingle(item.value)">
                  <span class="b1">{{ item.label }}</span>
                  @if (item.icon) {
                    <m-tooltip
                      [content]="item.icon.tooltip"
                      position="right"
                      styleClass="grouped-dropdown-item-tooltip"
                      tooltipStyleClass="grouped-dropdown-children-tooltip"
                      [tooltipOptions]="bodyTooltipOptions">
                      <em
                        class="material-symbols-outlined icon-small text-blue-400"
                        aria-hidden="true"
                        (click)="$event.stopPropagation()"
                        >{{ item.icon.name }}</em
                      >
                    </m-tooltip>
                  }
                </button>
              }
            } @else {
              @for (category of group.items; track category.value) {
                <p class="grouped-dropdown-category-title b2">
                  {{ category.label }}
                </p>

                @for (option of category.options ?? []; track option.value) {
                  @let optionDisabled =
                    isAttributeDisabled(category.value, option.value);
                  <label
                    class="grouped-dropdown-attribute"
                    [class.grouped-dropdown-attribute-disabled]="optionDisabled"
                    (click)="$event.stopPropagation()">
                    <p-checkbox
                      [binary]="true"
                      [disabled]="optionDisabled"
                      [ngModel]="
                        isAttributeChecked(category.value, option.value)
                      "
                      (ngModelChange)="
                        onAttributeToggle(category.value, option.value, $event)
                      ">
                    </p-checkbox>
                    <span class="b1">{{ option.label }}</span>
                  </label>
                }
              }
            }
          }
        }
      </div>
    </div>
  </p-popover>
</div>
